export const CCM19_API_KEY = "c9de052f9cfad9ef630d69c806e3cd3b9ba5b01081023ea7"
export const CCM19_DOMAIN = "667dafe6bdc7ded07a058cc2"
export const CCM19_THEME = "667dafe6bdc7ded07a058cd1"
